module.exports = __webpack_public_path__ + "img/comLogo.50305539.png";